import React, { useEffect, useState } from 'react'
import { BarChart, Bar,ResponsiveContainer, CartesianGrid,Tooltip,Legend, XAxis, YAxis } from 'recharts';
import { filterUsers, loadUsers } from '../../utils/Network';

function PollReportBarChart({poll_results}) {
    const data = [];
    console.log(poll_results)
    if(poll_results){
        poll_results?.forEach(item => {
            data.push({
                name : item?.pollitem.usertalent?.user.profile.first_name,
                votes :item.vote
            })
        });
    }
    
        
    return (
        <ResponsiveContainer width="100%" height={500}>
        <BarChart
		data={data}
		margin={{
			top: 5, right: 5, left: 5, bottom: 5,
		}}
	>
		<CartesianGrid strokeDasharray="3 3" />
		<XAxis dataKey="name" />
		<YAxis dataKey="votes" />
		<Tooltip />
        <Bar dataKey="votes" fill="#38a1bb" />
		<Legend margin={{
			top: 5, right: 5, left: 5, bottom: 5,
		}} />
	</BarChart>
    </ResponsiveContainer>
    )
}

export default PollReportBarChart